//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapState } from 'vuex'
export default {
	computed: {
		...mapState({
			video: ({ resourcesStore: {video} }) => video
		})
	},
}
